module.exports = __webpack_public_path__ + "img/delivery-guy.bba80e86.svg";